<mbs-modal [title]="'shared:wasabiMinimumRetentionPeriod.title' | i18next">
  <ng-container modal-body>
    <mbs-alert [type]="mbsPopupType.warning"
               [icon]="true">
      <div>{{ 'shared:wasabiMinimumRetentionPeriod.alertText' | i18next }}</div>

      <a [helpLink]="'/billing-storage/storage-providers/wasabi/min-retention-policy'"
         target="_blank"> {{'shared:buttons.learnMore' | i18next}} </a>
    </mbs-alert>

    <mbs-form-group class="mb-0">
      <h5 class="mb-2">{{ 'shared:wasabiMinimumRetentionPeriod.retentionPeriod' | i18next }}</h5>

      <mbs-form-group>
        <mbs-radio name="periodVariants"
                   [disabled]="loading"
                   [label]="'shared:wasabiMinimumRetentionPeriod.small' | i18next"
                   [value]="periodVariants.WasabiSmall"
                   [formControl]="durationControl"
                   [id]="'wasabi-small-radio'"></mbs-radio>

        <mbs-radio name="periodVariants"
                   [disabled]="loading"
                   [label]="'shared:wasabiMinimumRetentionPeriod.big' | i18next"
                   [value]="periodVariants.WasabiBig"
                   [formControl]="durationControl"
                   [id]="'wasabi-big-radio'"></mbs-radio>
      </mbs-form-group>
    </mbs-form-group>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button [type]="'primary'"
                class="mr-2"
                [loading]="loading"
                (click)="selectClickHandler()">Save</mbs-button>
    <mbs-button [type]="'secondary'"
                [loading]="loading"
                (click)="cancelClickHandler()">Cancel</mbs-button>
  </ng-container>
</mbs-modal>

<ng-template #warningModalTemplate>
  <div>
    {{ 'shared:wasabiMinimumRetentionPeriod.alertModalText' | i18next }}
  </div>
</ng-template>
